var _excluded = ["disable", "labelExpr", "selections"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { LEGEND_SCALE_CHANNELS } from '../../legend';
import { keys, replaceAll, stringify, vals } from '../../util';
import { isSignalRef } from '../../vega.schema';
import { mergeLegendComponent } from './parse';
function setLegendEncode(legend, part, vgProp, vgRef) {
  var _legend$encode, _a$part, _b$update;
  var _a, _b;
  (_legend$encode = legend.encode) !== null && _legend$encode !== void 0 ? _legend$encode : legend.encode = {};
  (_a$part = (_a = legend.encode)[part]) !== null && _a$part !== void 0 ? _a$part : _a[part] = {};
  (_b$update = (_b = legend.encode[part]).update) !== null && _b$update !== void 0 ? _b$update : _b.update = {};
  // TODO: remove as any after https://github.com/prisma/nexus-prisma/issues/291
  legend.encode[part].update[vgProp] = vgRef;
}
export function assembleLegends(model) {
  var legendComponentIndex = model.component.legends;
  var legendByDomain = {};
  var _iterator = _createForOfIteratorHelper(keys(legendComponentIndex)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var channel = _step.value;
      var scaleComponent = model.getScaleComponent(channel);
      var domainHash = stringify(scaleComponent.get('domains'));
      if (legendByDomain[domainHash]) {
        var _iterator2 = _createForOfIteratorHelper(legendByDomain[domainHash]),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var mergedLegendComponent = _step2.value;
            var merged = mergeLegendComponent(mergedLegendComponent, legendComponentIndex[channel]);
            if (!merged) {
              // If cannot merge, need to add this legend separately
              legendByDomain[domainHash].push(legendComponentIndex[channel]);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } else {
        legendByDomain[domainHash] = [legendComponentIndex[channel].clone()];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var legends = vals(legendByDomain).flat().map(function (l) {
    return assembleLegend(l, model.config);
  }).filter(function (l) {
    return l !== undefined;
  });
  return legends;
}
export function assembleLegend(legendCmpt, config) {
  var _legend$encode2;
  var _legendCmpt$combine = legendCmpt.combine(),
    disable = _legendCmpt$combine.disable,
    labelExpr = _legendCmpt$combine.labelExpr,
    selections = _legendCmpt$combine.selections,
    legend = _objectWithoutProperties(_legendCmpt$combine, _excluded);
  if (disable) {
    return undefined;
  }
  if (config.aria === false && legend.aria == undefined) {
    legend.aria = false;
  }
  if ((_legend$encode2 = legend.encode) !== null && _legend$encode2 !== void 0 && _legend$encode2.symbols) {
    var out = legend.encode.symbols.update;
    if (out.fill && out.fill['value'] !== 'transparent' && !out.stroke && !legend.stroke) {
      // For non color channel's legend, we need to override symbol stroke config from Vega config if stroke channel is not used.
      out.stroke = {
        value: 'transparent'
      };
    }
    // Remove properties that the legend is encoding.
    var _iterator3 = _createForOfIteratorHelper(LEGEND_SCALE_CHANNELS),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var property = _step3.value;
        if (legend[property]) {
          delete out[property];
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  if (!legend.title) {
    // title schema doesn't include null, ''
    delete legend.title;
  }
  if (labelExpr !== undefined) {
    var _legend$encode3;
    var expr = labelExpr;
    if ((_legend$encode3 = legend.encode) !== null && _legend$encode3 !== void 0 && (_legend$encode3 = _legend$encode3.labels) !== null && _legend$encode3 !== void 0 && _legend$encode3.update && isSignalRef(legend.encode.labels.update.text)) {
      expr = replaceAll(labelExpr, 'datum.label', legend.encode.labels.update.text.signal);
    }
    setLegendEncode(legend, 'labels', 'text', {
      signal: expr
    });
  }
  return legend;
}